import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useSession, useSettingsSections } from '@/hooks';
import { SettingsLayout } from './SettingsLayout';

export function SettingsPage() {
  const { isAuthenticated } = useSession();
  const { getSection } = useSettingsSections();
  const { section } = useParams();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={`/signin?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  // Resolve section: default to 'account'; unknown id → redirect to /settings.
  const active = section ?? 'account';
  if (section && !getSection(section)) {
    return <Navigate to="/settings" replace />;
  }
  return <SettingsLayout activeId={active} />;
}
